export const rootPath = () => '/noon-question'
export const questions1Path = () => '/noon-question/question-1'
export const questions2Path = () => '/noon-question/question-2'
export const questions3Path = () => '/noon-question/question-3'
export const summaryPath = () => '/noon-question/summary'
